import script from "./MCF_BT_004.vue?vue&type=script&setup=true&lang=js"
export * from "./MCF_BT_004.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__